'use client';

import { Box, Container } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { LazyDither } from '@/components/Dither';
import SectionTitleSimple from '@/components/SectionTitleSimple';

import styles from './ClientRelationshipsSection.module.scss';

const ClientRelationshipsSection = () => {
  const t = useTranslations('common.clientRelationshipsSection');

  return (
    <Container component="section" maxWidth={false} disableGutters className={styles.container}>
      <SectionTitleSimple
        title={t('title')}
        description={t('description')}
        link={{ href: '/work', text: t('buttonText') }}
        className={styles.title}
      />
      <Container maxWidth={false} disableGutters className={styles.content}>
        <Box className={styles.blur} />
        <LazyDither
          className={styles.bgImageContainer}
          density={120}
          size={2.5}
          brightnessFlickerAmount={0.002}
          fadeInDuration={0.8}
          src="/images/home/client-relationships/banner.webp"
        />
        <Box className={styles.bgImageContainerMobile}>
          <Image
            src="/images/home/client-relationships/banner-dithered.webp"
            alt="Client relationships"
            fill
            style={{ objectFit: 'cover' }}
          />
        </Box>
      </Container>
    </Container>
  );
};

export default ClientRelationshipsSection;
